import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ZipCodeRangeModel } from '../../../../shared/models/zip-code-range.model';
import { DistanceToDeadlineService } from '../../../services/distance-to-deadline.service';
import { SchedulingSettingsDatepickerService } from '../../../services/scheduling-settings-datepicker.service';

@Component({
    selector: 'payment-delivery-freights-freight-item',
    templateUrl: './payment.delivery.freights.freight-item.component.html',
    styleUrls: ['../../../payment.component.scss'],
    providers: []
})
export class PaymentDeliveryFreightsFreightItemComponent implements
    AfterViewInit,
    OnInit {
    public daysToDeadline = 0;
    public daysToDeadlineLimit = 0;
    @Input() freight: ZipCodeRangeModel;
    @Input() isChecked: boolean;
    @Output() changedSelectedFreight: EventEmitter<ZipCodeRangeModel> = new EventEmitter();

    constructor(
        protected distanceToDeadline: DistanceToDeadlineService
    ) {}

    ngOnInit() {
        this.daysToDeadline = this.distanceToDeadline.calculate(this.freight.time_cost);
        if (this.hasDefinedLimit()) {
            this.daysToDeadlineLimit = this.distanceToDeadline.calculate(this.freight.time_cost_limit);
        }
        this.hideScheduled();
    }
    ngAfterViewInit() {
        if (this.isChecked) {
            this.onChangeFreight();
        }
    }

    /**
     * This reset deliveryDataModel value and emit changed selected freight
     * event.
     **/
    public onChangeFreight(): void {
        if (!this.hasScheduleSettings()) {
            this.changedSelectedFreight.emit(this.freight);
        }
        this.hideScheduled();
        this.showScheduled(this.freight.id);
    }
    /**
     * This verify if zipCodeRange has deadline_limit.
     **/
    public hasDefinedLimit(): boolean {
        if (null === this.freight.time_cost_limit) {
            return false;
        }

        const deadlineLimitDistance = this.distanceToDeadline.calculate(this.freight.time_cost_limit);
        const deadlineDistance = this.distanceToDeadline.calculate(this.freight.time_cost);
        const difference = (deadlineLimitDistance - deadlineDistance);

        return this.freight.time_cost_limit !== null && difference > 0;
    }
    /**
     * This verify if zipCodeRange has schedule settings to display date picker.
     **/
    public hasScheduleSettings(): boolean {
        return this.freight.scheduling_settings !== undefined
            && this.freight.scheduling_settings.length > 0;
    }
    /**
     * Emit event that freight was selected.
     **/
    public scheduled() {
        this.changedSelectedFreight.emit(this.freight);
    }
    /**
     * Hide schendule
     **/
    public hideScheduled(): void {
        Array.from(
          document.querySelectorAll('.payment-delivery-freights-freight-item-schedule')
        ).forEach((el) => {
          (el as HTMLElement).style.display = 'none';
        });
    }

    public showScheduled(id): void {
        const el = document.querySelector(
          `#payment-delivery-freights-freight-item-schedule-${id}`
        ) as HTMLElement | null;
      
        if (el) {
          el.style.display = '';
        }
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2078029388/src/src/app/payment/delivery/freights/freight-item/payment.delivery.freights.freight-item.component.ts